import { BoxProps } from '@chakra-ui/react';
import React from 'react';

import { CmCard, CmHeading, CmText } from '@/components/uiParts';

interface Props extends BoxProps {
  title: string;
  desc: string;
}

export const KPICard: React.FC<Props> = ({ title, desc, ...rest }) => {
  return (
    <CmCard {...rest}>
      <CmHeading fontSize="sm" as="h1" size="xl">
        {title}
      </CmHeading>
      <CmText alignSelf="center" mt={2} fontSize="2xl" fontWeight="bold">
        {desc}
      </CmText>
    </CmCard>
  );
};
